
import React from 'react'
import {withFirestore} from 'react-firestore'
import Fade from 'react-reveal/Fade'
import TopHeaderMenu from '../components/TopHeaderMenu'
import MsgNetLoading from '../components/MsgNetLoading'
import {formatMs} from '../utils/time'

import '../scss/UltimosLocation.css'
import SharePanel from '../components/SharePanel'

const RESULTADOS_MOSTRAR = 15

class LocationDetailScreen extends React.Component {
// ...
  constructor (props) {
    super(props)

    this.ultimoTiempo = 0
    this.ultimoDorsal = 0

    this.state = {
      location: null,
      isLoading: true,
      isLoadingMore: false,
      hasMoreResults: true,
      evento: null,
      showSharePanel: false,
      resultados: [],
      controles: []
    }
  }

  toogleSharePanel () {
    this.setState(state => ({
      showSharePanel: !this.state.showSharePanel
    }))
  }

  onClickBack () {
    const eventoId = parseInt(this.props.match.params.eventoId, 10)

    this.props.history.push(`/${eventoId}/locations`)
  }

  componentDidMount () {
    // Cargamos o evento e a location que nos pasan na url
    const {firestore} = this.props
    const eventoId = parseInt(this.props.match.params.eventoId, 10)
    const locationId = parseInt(this.props.match.params.locationId, 10)

    firestore.doc('evento/' + eventoId).onSnapshot(snapshot => {
      let evento = snapshot ? snapshot.data() : null
      if (evento) {
        evento.id = snapshot.id
      }
      this.setState({evento})
    })
    firestore.doc('location/' + locationId).onSnapshot(snapshot => {
      let location = snapshot ? snapshot.data() : null
      if (location) {
        location.id = snapshot.id
        location.nombre = location.codigo // para mostrar en topbar...
      }
      this.setState({
        location,
        isLoading: false
      })
    })
  }

  componentWillUpdate (nextProps, nextState) {
    // Cando teñamos cargada a location, buscamos todos os resultados que
    // aparecen en algún dos controles relacionados con esta location.
    const {firestore} = this.props

    if (!this.state.location && nextState.location) {
      // console.info('CARGAR RESULTADOS!')
      // console.info('location_' + nextState.location.id + '_tiempo')
      firestore.collection('resultado/')
        .where('location_' + nextState.location.id + '_tiempo', '>', 0)
        .orderBy('location_' + nextState.location.id + '_tiempo', 'desc')
        .limit(RESULTADOS_MOSTRAR)
        .onSnapshot((snapshot) => {
          const resultados = snapshot.docs.map(doc => ({
            id: doc.id,
            ...doc.data()
          }))
          if (resultados.length) {
            this.ultimoTiempo = resultados[resultados.length - 1]['location_' + nextState.location.id + '_tiempo']
            this.ultimoDorsal = resultados[resultados.length - 1]['dorsal']
          }
          this.setState({
            resultados
          })
        // Ojito: onSnapshot pode executarse varias veces con != número de
        //        resultados ata que obten RESULTADOS_MOSTRAR.
        //   if (resultados.length < RESULTADOS_MOSTRAR) {
        //     this.setState({
        //       hasMoreResults: false
        //     })
        //   }
        })
      // Leemos os controles relacionados con cada location para poder
      // representar o tempo de paso correcto
      // console.info('location == ' + nextState.location.id)
      firestore.collection('control/')
        .where('location', '==', parseInt(nextState.location.id, 10))
        .onSnapshot((snapshot) => {
          // Gardamos os controles ordenados de mayor a menor
          const controles = snapshot.docs
            .map(doc => ({
              id: doc.id,
              ...doc.data()
            }))
            .sort((a, b) => b.distancia - a.distancia)

          this.setState({
            controles
          })
        })
    }
  }

  getMoreResultados () {
    const {location} = this.state
    const {firestore} = this.props

    firestore.collection('resultado/')
      .where('location_' + location.id + '_tiempo', '>', 0)
      .orderBy('location_' + location.id + '_tiempo', 'desc')
      .startAt(this.ultimoTiempo) // Pode haber varios resultados co mesmo tempo
      .limit(RESULTADOS_MOSTRAR)
      .onSnapshot((snapshot) => {
        const resultados = snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }))
        if (resultados.length) {
          const filtrados = []
          let dorsalEncontrado = false
          for (let i = 0; i < resultados.length; i++) {
            if (dorsalEncontrado) {
              filtrados.push(resultados[i])
            }
            if (resultados[i].dorsal === this.ultimoDorsal) {
              dorsalEncontrado = true
            }
          }
          // console.info(filtrados)
          this.ultimoTiempo = resultados[resultados.length - 1]['location_' + location.id + '_tiempo']
          this.ultimoDorsal = resultados[resultados.length - 1]['dorsal']
          this.setState({
            resultados: this.state.resultados.concat(filtrados),
            isLoadingMore: false
          })
          // Ojito: onSnapshot pode executarse varias veces con != número de
          //        resultados ata que obten RESULTADOS_MOSTRAR.
          // if (resultados.length < RESULTADOS_MOSTRAR) {
          //   this.setState({
          //     hasMoreResults: false
          //   })
          // }
        } else {
          this.setState({
            hasMoreResults: false
          })
        }
      })
  }

  loadMore () {
    this.setState({
      isLoadingMore: true
    })
    this.getMoreResultados()
  }

  render () {
    const {
      evento, isLoading, resultados, controles, location,
      isLoadingMore, hasMoreResults
    } = this.state

    const _getLastControlInLocation = resultado => {
      for (let i = 0; i < controles.length; i++) {
        if (resultado['control_' + controles[i].id + '_tiempo']) {
          return controles[i]
        }
      }
      return null
    }

    return (
      <div>
        <TopHeaderMenu
          competicion={location}
          evento={evento}
          onClickBack={this.onClickBack.bind(this)}
          onClickShare={this.toogleSharePanel.bind(this)}
        />
        {isLoading ? (
          <MsgNetLoading />
        ) : (
          (evento && evento.visible) ? (
            (resultados.length && controles.length) ? (
              <div>
                {this.state.showSharePanel && (
                  <SharePanel
                    close={this.toogleSharePanel.bind(this)}
                    url={`/${evento.id}/locations/${location.id}`}
                    title={`Atletas pasando por ${location.codigo} en ${evento.nombre}`}
                  />
                )}
                <ul className='ultimos'>
                  {resultados.map((resultado) => {
                    const control = _getLastControlInLocation(resultado)
                    const controlNombre = control ? control.nombre : '---'
                    const tiempo = (control && resultado['control_' + control.id + '_tiempo']) ? resultado['control_' + control.id + '_tiempo'] : 0
                    const puesto = (control && resultado['control_' + control.id + '_puesto']) ? resultado['control_' + control.id + '_puesto'] : '---'
                    return <Fade top><li key={resultado.id} className='ultimos__item'>
                      <div className='ultimos__dorsal'>
                        D{resultado.dorsal}
                      </div>
                      <div className='ultimos__body'>
                        <div className='ultimos__nombre'>
                          {resultado.nombre} {resultado.apellidos}
                        </div>
                        <div className='ultimos__tiempo'>
                          {formatMs(tiempo)}
                        </div>
                      </div>
                      <div className='ultimos__footer'>
                        A las {formatMs(
                          resultado['location_' + location.id + '_tiempo'])}
                        &nbsp; en &nbsp;
                        {controlNombre}
                        &nbsp; (p {puesto})
                      </div>
                    </li></Fade>
                  })}
                </ul>
                {hasMoreResults && (
                  (isLoadingMore ? (
                    <MsgNetLoading />
                  ) : (
                    <div className='load-more__wrapper'>
                      <button className='load-more__btn' onClick={this.loadMore.bind(this)}>
                        Cargar Más
                      </button>
                    </div>
                  ))
                )}
              </div>
            ) : (
              <div>
                <br />
                <h2 className={'text-center'}>Sin resultados</h2>
              </div>
            )
          ) : (
            <div>
              <br />
              <h2 className={'text-center'}>No se ha podido encontrar el evento especificado</h2>
            </div>
          )
        )}
      </div>
    )
  }
}

export default withFirestore(LocationDetailScreen)



// WEBPACK FOOTER //
// ./src/containers/LocationDetailScreen.js